import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './Sidebar/Sidebar';
import Navbar from './Navbar/Navbar';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // mobile overlay
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // desktop collapse

  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  // const toggleSidebar = useCallback(
  //   () => setSidebarOpen((prev) => !prev),
  //   []
  // );

  /* Close on Escape key */
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeSidebar();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [closeSidebar]);

  /* Lock body scroll when mobile sidebar is open */
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sidebarOpen]);

  return (
    <div className="layout-container">

      {/* ── Navbar ─────────────────────────────────── */}
      <Navbar />

      {/* ── Body ───────────────────────────────────── */}
      <div className="layout-body">

        {/* Dark overlay — mobile/tablet only */}
        <div
          className={`sidebar-overlay ${sidebarOpen ? 'sidebar-overlay--visible' : ''}`}
          onClick={closeSidebar}
        />

        <Sidebar
          isOpen={sidebarOpen}
          onClose={closeSidebar}
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
        />

        <main className="main-content">
          <div className="content-wrapper">
            {children}
          </div>
        </main>

      </div>
    </div>
  );
};

export default Layout;